import gql from "graphql-tag"

const catalogFields = gql`
  fragment HomeMovieFields on Movie {
    id
    name
    tmdbOptions
    isViewable
    additionDate
  }

  fragment HomeShowFields on Show {
    id
    name
    tmdbOptions
    status
    additionDate
  }

  fragment HomeCollectionFields on Collection {
    id
    name
    tmdbOptions
    status
    additionDate
  }
`

export default gql`
  ${catalogFields}

  query homeDiscovery($limit: Int!) {
    recent: catalogRecentlyAdded(limit: $limit) {
      __typename
      ... on Movie { ...HomeMovieFields }
      ... on Show { ...HomeShowFields }
      ... on Collection { ...HomeCollectionFields }
    }
    friends: friendMediaList {
      __typename
      ... on Movie { ...HomeMovieFields }
      ... on Show { ...HomeShowFields }
      ... on Collection { ...HomeCollectionFields }
    }
  }
`
